export function commercialReaReducer(state = "",{
    type,
    payload
}){
    
    switch(type){
        case "NEW_COMMERCIAL_REA": 
            return {
                [payload.id]: payload,
                ...state
            };

        case "UPDATE_COMMERCIAL_REA": 
            return {
                ...state,
                [payload.id]: payload
            } 
            
        case "GET_COMMERCIAL_REAS":        
            return payload;
        
        case "DELETE_COMMERCIAL_REA":
            const { [payload]: deleted, ...newState } = state;
            return newState;
        default:
            return state;
    }
    
}